<template>
  <div class="w-full h-full">
    <div class="flex justify-between items-center">
      <div class="title text-lg mb-10px cursor-pointer">
        <el-page-header
          v-if="formProps.pageType === 'read'"
          @back="$emit('cancel')"
          content="详情"
        ></el-page-header>
        <span
          v-if="formProps.pageType !== 'read'"
          class="border-l-3 border-color-primary pl-10px text-18px"
          >{{ formProps.pageType === 'create' ? '新增' : '编辑' }}</span
        >
      </div>
    </div>
    <div
      class="w-full overflow-y-auto overflow-x-hidden"
      :class="[formProps.pageType === 'read' ? 'detail-height' : 'custom-height']"
    >
      <el-form ref="form" label-width="140px" :rules="rules" :model="formData">
        <el-collapse v-model="collapseActiveName">
          <el-collapse-item title="基本信息" name="baseInfo">
            <el-row :gutter="20">
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
                <el-form-item label="辨识计划名称" prop="recognitionPlanName">
                  <el-input
                    v-model="formData.recognitionPlanName"
                    placeholder="请输入辨识计划名称"
                    maxlength="200"
                    show-word-limit
                    clearable
                    :disabled="['read', 'refreshPublish'].includes(formProps.pageType)"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
                <el-form-item label="辨识主题" prop="recognitionPlanTopic">
                  <el-input
                    v-model="formData.recognitionPlanTopic"
                    placeholder="请输入辨识主题"
                    maxlength="200"
                    show-word-limit
                    clearable
                    :disabled="['read', 'refreshPublish'].includes(formProps.pageType)"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
                <el-form-item
                  label="计划时间"
                  prop="dateArr"
                  v-if="formProps.pageType !== 'refreshPublish'"
                >
                  <el-date-picker
                    size="small"
                    v-model="formData.dateArr"
                    :disabled="formProps.pageType === 'read'"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetimerange"
                    class="w-full"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    @change="dateChange"
                    clearable
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="计划结束时间" prop="planTimeEnd" v-else>
                  <el-date-picker
                    size="small"
                    v-model="formData.planTimeEnd"
                    :disabled="formProps.pageType === 'read'"
                    type="datetime"
                    class="w-full"
                    placeholder="请选择计划结束时间"
                    :picker-options="pickerOptions"
                    clearable
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
                <el-form-item
                  label="计划管控负责人"
                  prop="planHeadControlId"
                  ref="planHeadControlId"
                >
                  <person-select
                    v-model="formData.planHeadControlId"
                    :disabled="['read', 'refreshPublish'].includes(formProps.pageType)"
                    @change="changePersonSelect('planHeadControlId')"
                  ></person-select>
                </el-form-item>
              </el-col>

              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
                <el-form-item label="分析辨识类型" prop="analyzeEvaluationType">
                  <el-radio-group
                    v-model="formData.analyzeEvaluationType"
                    :disabled="
                      this.formData.sourcesDangerRecognitionPlanTaskDtos &&
                        this.formData.sourcesDangerRecognitionPlanTaskDtos.length > 0
                    "
                  >
                    <el-radio
                      v-for="item in evaluateList"
                      :key="Number(item.code)"
                      :disabled="['read', 'refreshPublish'].includes(formProps.pageType)"
                      :label="Number(item.code)"
                      >{{ item.displayName }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item name="taskAssign" title="任务分配">
            <el-row>
              <el-col :span="24" class="flex justify-end items-center flex-wrap">
                <div class="text-right">
                  <el-button
                    :disabled="['read', 'refreshPublish'].includes(formProps.pageType)"
                    size="small"
                    type="primary"
                    class="mb-20px"
                    @click="handleFormEvent(null, 'chooseRiskPoint')"
                    >选择风险点</el-button
                  >
                  <el-button
                    :disabled="['read', 'refreshPublish'].includes(formProps.pageType)"
                    size="small"
                    type="primary"
                    class="mb-20px"
                    @click="handleFormEvent(null, 'updateLeader')"
                    >批量修改辨识负责人</el-button
                  >
                  <el-button
                    :disabled="['read', 'refreshPublish'].includes(formProps.pageType)"
                    size="small"
                    type="primary"
                    class="mb-20px"
                    @click="handleFormEvent(null, 'updateIdentifyMethod')"
                    >批量修改辨识方法</el-button
                  >
                  <el-button
                    :disabled="['read', 'refreshPublish'].includes(formProps.pageType)"
                    size="small"
                    type="primary"
                    class="mb-20px"
                    @click="handleFormEvent(null, 'updateEvaluateMethod')"
                    >批量修改评价方法</el-button
                  >
                  <el-button
                    :disabled="['read', 'refreshPublish'].includes(formProps.pageType)"
                    size="small"
                    type="danger"
                    class="mb-20px"
                    @click="handleFormEvent(null, 'batchDelete')"
                    >批量删除</el-button
                  >
                </div>
              </el-col>
              <el-col :span="24">
                <el-table
                  :data="formData.sourcesDangerRecognitionPlanTaskDtos"
                  border
                  class="w-full mb-20px"
                  :height="tableHeight"
                  stripe
                  @selection-change="handleSelection"
                >
                  <el-table-column type="selection" width="50"></el-table-column>
                  <el-table-column type="index" label="序号" width="50"></el-table-column>
                  <el-table-column
                    label="风险点名称"
                    prop="riskPointName"
                    show-overflow-tooltip
                  ></el-table-column>

                  <el-table-column prop="title" width="260" show-overflow-tooltip>
                    <template slot="header">
                      <span class="mr-0.5 text-red-500 text-sm text-slate-700">*</span>
                      <span>辨识方法</span>
                    </template>
                    <template slot-scope="scope">
                      <el-form-item
                        class="form-nolabel"
                        :prop="
                          `sourcesDangerRecognitionPlanTaskDtos.${scope.$index}.recognitionMethod`
                        "
                        :rules="{
                          required: true,
                          message: '请选择辨识方法',
                          trigger: ['change', 'blur'],
                        }"
                      >
                        <el-select
                          v-model="
                            formData.sourcesDangerRecognitionPlanTaskDtos[scope.$index]
                              .recognitionMethod
                          "
                          class="w-full"
                          placeholder="请选择辨识方法"
                          filterable
                          clearable
                          :disabled="['read', 'refreshPublish'].includes(formProps.pageType)"
                        >
                          <el-option
                            v-for="item in identifyMethodsList"
                            :key="item.code"
                            :label="item.displayName"
                            :value="Number(item.code)"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </template>
                  </el-table-column>

                  <el-table-column prop="planStartDate" width="260" show-overflow-tooltip>
                    <template slot="header">
                      <span class="mr-0.5 text-red-500 text-sm text-slate-700">*</span>
                      <span>评价方法</span>
                    </template>
                    <template slot-scope="scope">
                      <el-form-item
                        class="form-nolabel"
                        :prop="
                          `sourcesDangerRecognitionPlanTaskDtos.${scope.$index}.evaluateMethod`
                        "
                        :rules="{
                          required: true,
                          message: '请选择评价方法',
                          trigger: ['change', 'blur'],
                        }"
                      >
                        <el-select
                          v-model="
                            formData.sourcesDangerRecognitionPlanTaskDtos[scope.$index]
                              .evaluateMethod
                          "
                          class="w-full"
                          placeholder="请选择评价方法"
                          filterable
                          clearable
                          :disabled="['read', 'refreshPublish'].includes(formProps.pageType)"
                        >
                          <el-option
                            v-for="item in evaluateMethodsList"
                            :key="item.code"
                            :label="item.displayName"
                            :value="Number(item.code)"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </template>
                  </el-table-column>

                  <el-table-column prop="planEndDate" width="260" show-overflow-tooltip>
                    <template slot="header">
                      <span class="mr-0.5 text-red-500 text-sm text-slate-700">*</span>
                      <span>风险辨识评价负责人</span>
                    </template>
                    <template slot-scope="scope">
                      <el-form-item
                        class="form-nolabel"
                        :prop="
                          `sourcesDangerRecognitionPlanTaskDtos.${scope.$index}.riskRecognitionEvaluationLeaderId`
                        "
                        :rules="{
                          required: true,
                          message: '请选择负责人',
                          trigger: ['change', 'blur'],
                        }"
                        :ref="
                          `sourcesDangerRecognitionPlanTaskDtos.${scope.$index}.riskRecognitionEvaluationLeaderId`
                        "
                      >
                        <person-select
                          :key="scope.$index"
                          class="!w-full mt-2px"
                          v-model="
                            formData.sourcesDangerRecognitionPlanTaskDtos[scope.$index]
                              .riskRecognitionEvaluationLeaderId
                          "
                          :disabled="['read', 'refreshPublish'].includes(formProps.pageType)"
                          @change="
                            changePersonSelect(
                              `sourcesDangerRecognitionPlanTaskDtos.${scope.$index}.riskRecognitionEvaluationLeaderId`
                            )
                          "
                        ></person-select>
                      </el-form-item>
                    </template>
                  </el-table-column>

                  <el-table-column label="操作" fixed="right" width="120">
                    <template slot-scope="scope">
                      <el-button
                        :disabled="['read', 'refreshPublish'].includes(formProps.pageType)"
                        size="mini"
                        @click="handleFormEvent(scope, 'delete')"
                        >删除</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-form>
    </div>
    <div
      class="w-full flex justify-center items-center mt-5 mb-5"
      v-if="formProps.pageType !== 'read' && formProps.pageType !== 'refreshPublish'"
    >
      <el-button
        type="primary"
        size="small"
        @click="submitForm('submit')"
        :disabled="pubLoading"
        :loading="saveLoading"
        >保存</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="submitForm('publish')"
        :disabled="saveLoading"
        :loading="pubLoading"
        >发布</el-button
      >
      <el-button @click="$emit('cancel')" size="small">取消</el-button>
    </div>
    <div class="w-full flex justify-center mt-20px" v-if="formProps.pageType === 'refreshPublish'">
      <el-button type="primary" size="small" @click="submitForm('publish')" :loading="pubLoading"
        >重新发布</el-button
      >
      <el-button @click="$emit('cancel')" size="small">取消</el-button>
    </div>

    <!-- 选择风险点 -->
    <choose-risk-point-form
      v-if="pointDialog"
      :types="formData.analyzeEvaluationType"
      :taskIds="taskIds"
      :pointProps="pointProps"
      @add-risk-point="addRiskPoint"
      @cancel="pointDialog = false"
    >
    </choose-risk-point-form>

    <!-- 批量修改负责人 -->
    <person-select
      ref="personSelect"
      v-model="formData.person"
      v-if="dialogChooseEvaluatePerson"
      @change="changePerson"
      :isShowUerInput="false"
    >
      <template></template>
    </person-select>

    <!-- 批量修改评价方法 -->
    <el-dialog
      :close-on-click-modal="false"
      append-to-body
      title="批量选择评价方法"
      :visible.sync="dialogChooseEvaluateMethod"
      class="mini-dialog"
      v-dialogDrag
    >
      <div v-if="dialogChooseEvaluateMethod">
        <el-form
          ref="formEvaluate"
          label-width="120px"
          :rules="rulesEvaluate"
          :model="formEvaluate"
        >
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item label="风险评价方法" prop="evaluateId">
                <el-select
                  v-model="formEvaluate.evaluateId"
                  size="small"
                  placeholder="请选择险评价方法"
                  filterable
                  clearable
                >
                  <el-option
                    v-for="item in evaluateMethodsList"
                    :key="item.code"
                    :label="item.displayName"
                    :value="Number(item.code)"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer flex justify-center items-center">
        <el-button size="small" type="primary" @click="submitFormUpdate('formEvaluate', 'evaluate')"
          >确定</el-button
        >
        <el-button size="small" @click="dialogChooseEvaluateMethod = false">取消</el-button>
      </div>
    </el-dialog>

    <!-- 批量修改辨识方法 -->
    <el-dialog
      :close-on-click-modal="false"
      append-to-body
      title="批量选择评价方法"
      :visible.sync="dialogChooseIdentifyMethod"
      class="mini-dialog"
      v-dialogDrag
    >
      <div v-if="dialogChooseIdentifyMethod">
        <el-form
          ref="formIdentify"
          label-width="120px"
          :rules="rulesIdentify"
          :model="formIdentify"
        >
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item label="风险辨识方法" prop="identifyId">
                <el-select
                  v-model="formIdentify.identifyId"
                  size="small"
                  placeholder="请选择风险辨识方法"
                  filterable
                  clearable
                >
                  <el-option
                    v-for="item in identifyMethodsList"
                    :key="item.code"
                    :label="item.displayName"
                    :value="Number(item.code)"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer flex justify-center items-center"
        v-if="formProps.pageType !== 'read'"
      >
        <el-button size="small" type="primary" @click="submitFormUpdate('formIdentify', 'identify')"
          >确定</el-button
        >
        <el-button size="small" @click="dialogChooseIdentifyMethod = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import PersonSelect from '@/components/safety/FormSelect/PersonSelect'
import { SourcesDangerRecognitionPlanApi } from '@wiz-api/double-prevention-management'
import utils from '@/components/safety/enumField/utils'
import ChooseRiskPointForm from './ChooseRiskPointForm'

const sourcesDangerRecognitionPlanApi = new SourcesDangerRecognitionPlanApi()
export default {
  name: 'risk-identify-form',
  components: {
    ChooseRiskPointForm,
    PersonSelect,
  },
  props: {
    FormData: {
      type: Object,
      default: () => {},
    },
    /**
     * @description: 上传传递的参数
     * @param {控制弹窗显示隐藏} visible
     * @return {*}
     */
    formProps: {
      type: Object,
      default: () => {
        return {
          // create 新增 update 编辑 read 详情
          pageType: 'create',
        }
      },
    },
  },
  data() {
    const validateDate = (rule, value, callback) => {
      if (!this.formData.dateArr || this.formData.dateArr.length === 0) {
        callback(new Error('请选择计划时间'))
        return
      }
      callback()
    }
    return {
      pickerOptions: {
        disabledDate(v) {
          return v.getTime() < new Date().getTime()
        },
      },
      collapseActiveName: ['baseInfo', 'taskAssign'],
      dialogChooseEvaluatePerson: false,
      selectionData: [],
      dialogChooseEvaluateMethod: false,
      chooseEvaluateList: [],
      formEvaluate: {
        evaluateId: undefined,
      },
      rulesEvaluate: {
        evaluateId: [{ required: true, message: '请选择评价方法', trigger: ['blur'] }],
      },
      dialogChooseIdentifyMethod: false,
      identifyMethodsList: [],
      evaluateMethodsList: [],
      formIdentify: {
        identifyId: undefined,
      },
      rulesIdentify: {
        identifyId: [{ required: true, message: '请选择辨识方法', trigger: ['blur'] }],
      },
      // 风险点
      pointProps: {
        visible: false,
      },
      pointDialog: false,
      pubLoading: false,
      saveLoading: false,
      formData: null,
      rules: {
        recognitionPlanName: [{ required: true, message: '请输入活动作业名称', trigger: ['blur'] }],
        dateArr: [{ required: true, validator: validateDate, trigger: ['blur'] }],
        planHeadControlId: [
          { required: true, message: '请选择计划管控负责人', trigger: ['blur', 'change'] },
        ],
        analyzeEvaluationType: [
          { required: true, message: '请选择风险辨识类型', trigger: ['blur', 'change'] },
        ],
        planTimeEnd: [{ required: true, message: '请选择计划结束时间', trigger: ['blur'] }],
      },
      evaluateList: [
        {
          code: 1,
          displayName: '设备设施类',
        },
        {
          code: 0,
          displayName: '作业清单类',
        },
      ],
    }
  },
  watch: {
    FormData: {
      handler(newVal, oldVal) {
        this.formData = newVal
      },
      immediate: true,
    },
  },
  computed: {
    tableHeight() {
      return this.formProps.pageType === 'read' ? 'calc(100vh - 400px)' : 'calc(100vh - 450px)'
    },
    taskIds() {
      // 传入
      return _.map(this.formData.sourcesDangerRecognitionPlanTaskDtos, (item) => {
        return item.riskActivityRelationalId
      })
    },
  },
  created() {
    utils.getDataCategory(
      [
        'DoublePreventionManagement.DataCategory.IdentifyMethods',
        'DoublePreventionManagement.DataCategory.EvaluateMethods',
      ],
      ['identifyMethodsList', 'evaluateMethodsList'],
      this
    )
  },
  methods: {
    changePersonSelect(key) {
      this.$refs[key].$emit('el.form.change')
    },
    // 批量修改人员
    changePerson(id) {
      this.formData.sourcesDangerRecognitionPlanTaskDtos.forEach((item) => {
        if (this.selectionData && this.selectionData.length > 0) {
          if (this.selectionData.includes(item.riskActivityRelationalId)) {
            item.riskRecognitionEvaluationLeaderId = id
          }
        } else {
          item.riskRecognitionEvaluationLeaderId = id
        }
      })
    },
    // 添加风险测点
    addRiskPoint(data) {
      this.formData.sourcesDangerRecognitionPlanTaskDtos = [
        ...data,
        ...this.formData.sourcesDangerRecognitionPlanTaskDtos,
      ]
      this.pointProps.visible = false
      this.pointDialog = false
    },
    // 获取选中的数据
    handleSelection(values) {
      this.selectionData = values.map((item) => {
        return item.riskActivityRelationalId
      })
    },

    /**
     * 批量修改操作保存
     * @param {*} formRefs form表单校验的ref
     * @param {*} operation 操作 当前批量修改哪个模块
     */
    submitFormUpdate(formRefs, operation) {
      // 点击确定后,清空选择数据
      const selectionData = this.selectionData
      // this.selectionData = []
      switch (operation) {
        case 'evaluate':
          this.$refs[formRefs].validate((valid) => {
            if (valid) {
              this.formData.sourcesDangerRecognitionPlanTaskDtos.forEach((item) => {
                if (selectionData && selectionData.length > 0) {
                  if (selectionData.includes(item.riskActivityRelationalId)) {
                    item.evaluateMethod = this.formEvaluate.evaluateId
                  }
                }
              })
              this.dialogChooseEvaluateMethod = false
            }
          })
          break
        case 'identify':
          this.$refs[formRefs].validate((valid) => {
            if (valid) {
              this.formData.sourcesDangerRecognitionPlanTaskDtos.forEach((item) => {
                if (selectionData && selectionData.length > 0) {
                  if (selectionData.includes(item.riskActivityRelationalId)) {
                    item.recognitionMethod = this.formIdentify.identifyId
                  }
                }
              })
              this.dialogChooseIdentifyMethod = false
            }
          })
          break
        default:
          break
      }
    },
    // 列表操作-事件
    handleFormEvent(row = null, operation) {
      // 选择风险点和删除不需要warning
      if (!['chooseRiskPoint', 'delete'].includes(operation)) {
        if (!this.selectionData || this.selectionData.length === 0) {
          this.$message({
            showClose: true,
            message: '请勾选风险点',
            type: 'warning',
          })
          return
        }
      }
      switch (operation) {
        // 删除
        case 'delete':
          this.$confirm('是否删除该记录？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              this.formData.sourcesDangerRecognitionPlanTaskDtos.splice(row.$index, 1)
              this.$nextTick(() => {})
            })
            .catch(() => {})
          break
        // 批量修改辨识负责人
        case 'updateLeader':
          this.dialogChooseEvaluatePerson = true
          this.$nextTick(() => {
            this.$refs.personSelect.organDialog = true
          })
          break
        // 批量修改辨识方法
        case 'updateIdentifyMethod':
          // 初始化表单
          this.formIdentify = this.$options.data().formIdentify
          this.dialogChooseIdentifyMethod = true
          break
        // 批量修改评价方法
        case 'updateEvaluateMethod':
          // 初始化表单
          this.formEvaluate = this.$options.data().formEvaluate
          this.dialogChooseEvaluateMethod = true
          break
        // 选择风险点
        case 'chooseRiskPoint':
          this.pointProps.visible = true
          this.pointDialog = true
          break
        // 批量删除
        case 'batchDelete':
          this.$confirm('是否删除已勾选记录？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              const sourcesDangerRecognitionPlanTaskDtos = JSON.parse(
                JSON.stringify(this.formData.sourcesDangerRecognitionPlanTaskDtos)
              )
              this.formData.sourcesDangerRecognitionPlanTaskDtos = _.filter(
                sourcesDangerRecognitionPlanTaskDtos,
                (item) => {
                  return !this.selectionData.includes(item.riskActivityRelationalId)
                }
              )
            })
            .catch(() => {})
          break
        default:
          break
      }
    },
    // 日期改变
    dateChange(value) {
      if (value && value.length > 0) {
        this.formData.planTimeStart = value[0]
        this.formData.planTimeEnd = value[1]
      }
    },
    /**
     * 表单提交
     * @param {*} type 操作类型 保存还是发布
     */
    async submitForm(type) {
      if (
        !this.formData.sourcesDangerRecognitionPlanTaskDtos ||
        this.formData.sourcesDangerRecognitionPlanTaskDtos.length === 0
      ) {
        this.$message({
          showClose: true,
          message: '请选择风险点',
          type: 'warning',
        })
        return
      }
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          // 时间格式化
          this.formData.planTimeStart =
            this.formData.planTimeStart &&
            dayjs(this.formData.planTimeStart).format('YYYY-MM-DD HH:mm:ss')
          this.formData.planTimeEnd =
            this.formData.planTimeEnd &&
            dayjs(this.formData.planTimeEnd).format('YYYY-MM-DD HH:mm:ss')
          type === 'submit' ? (this.saveLoading = true) : (this.pubLoading = true)
          let err = null
          let res = null
          this.formData = utils.deleteFormField(this.formData)

          // 非重新发布
          if (this.formProps.pageType !== 'refreshPublish') {
            if (type === 'submit') {
              // publishStatus 0代表新增 1代表发布
              this.formData.publishStatus = 0
              if (this.formData.id) {
                // 编辑
                ;[err, res] = await sourcesDangerRecognitionPlanApi.update(this.formData.id, {
                  body: this.formData,
                })
              } else {
                // 新增
                ;[err, res] = await sourcesDangerRecognitionPlanApi.create({
                  body: this.formData,
                })
              }
            } else {
              this.formData.publishStatus = 1
              if (this.formData.id) {
                // 编辑
                ;[err, res] = await sourcesDangerRecognitionPlanApi.update(this.formData.id, {
                  body: this.formData,
                })
              } else {
                // 新增
                ;[err, res] = await sourcesDangerRecognitionPlanApi.create({
                  body: this.formData,
                })
              }
            }
          }
          // 重新发布
          if (this.formProps.pageType === 'refreshPublish') {
            ;[err, res] = await sourcesDangerRecognitionPlanApi.rePublishPlan({
              palanId: this.formData.id,
              planTimeEnd: this.formData.planTimeEnd,
            })
          }
          if (!err) {
            this.$emit('refreshList')
          }
          type === 'submit' ? (this.saveLoading = false) : (this.pubLoading = false)
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
.form-nolabel {
  ::v-deep .el-form-item__content {
    margin-left: 0 !important;
    margin-top: 20px !important;
  }
}

.custom-height {
  height: calc(100% - 95px);
}

.detail-height {
  height: calc(100% - 50px);
}
</style>
